"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLoaderGuard = dataLoaderGuard;
const app_1 = require("@kalkulacka-one/app");
const navigation_1 = require("next/navigation");
async function dataLoaderGuard({ endpoint, key, group }) {
    try {
        return await (0, app_1.loadCalculatorData)({ endpoint, key, group });
    }
    catch (error) {
        if (error instanceof app_1.NotFoundError) {
            (0, navigation_1.notFound)();
        }
        throw error;
    }
}
